module.exports = __webpack_public_path__ + "img/อยากแก้ไขตัวเลข_ คลิกตรงนี้.9be9a3a5.svg";